import React from "react";

export default function PageStatsCards({ PageName, CardsData }) {
  let cardData = [];

  const createCard = (cardTitle, cardBgColor, cardValue) => ({
    cardTitle,
    cardValue,
    cardBgColor,
  });

  switch (PageName) {
    case "Dashboard":
      cardData = [
        createCard("Confirmed", "bg-green-500", CardsData?.ConfirmedCount || 0),
        createCard(
          "Total Escalations",
          "bg-red-600",
          CardsData?.EscalationCount || 0
        ),
        createCard(
          "Reschedule",
          "bg-red-500",
          CardsData?.ReschedulecancelCount || 0
        ),
        createCard(
          "No Response",
          "bg-red-500",
          CardsData?.NoresponseCount || 0
        ),
      ];
      break;
    case "Escalations":
      cardData = {
        escalatedCalls: [
          createCard(
            "Escalations",
            "bg-red-600",
            CardsData?.TotalCalls || "0"
          ),
        ],
        escalatedHours: [
          createCard(
            "Total Hours",
            "bg-[#F4631E]",
            CardsData?.TotalCount || "0"
          ),
          createCard(
            "Reschedule Hours",
            "bg-[#FF7601]",
            CardsData?.RescheduleCount || "0"
          ),
          createCard(
            "No Response Hours",
            "bg-[#FF7601]",
            CardsData?.NoResponseCount || "0"
          ),
        ],
      };
      break;
    case "CompletedCalls":
      cardData = [
        createCard(
          "Initiated Calls",
          "bg-blue-500",
          CardsData?.InitiatedCount || 0
        ),
        createCard(
          "Accepted Calls",
          "bg-green-500",
          CardsData?.AcceptedCount || 0
        ),
        createCard("Missed Calls", "bg-red-500", CardsData?.MissedCount || 0),
        createCard(
          "Escalations",
          "bg-red-500",
          CardsData?.EscalationCount || 0
        ),
      ];
      break;
    default:
      break;
  }

  return PageName === "Escalations" ? (
    <>
      <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
        <div className="mb-4 xl:mr-14 lg:mr-10 md:mr-4 md:mb-0">
          {cardData.escalatedCalls.map((card, idx) => (
            <StatCard
              key={idx}
              cardTitle={card.cardTitle}
              cardBgColor={card.cardBgColor}
              cardValue={card.cardValue}
            />
          ))}
        </div>
        {cardData.escalatedHours.map((card, idx) => (
          <StatCard
            key={idx}
            cardTitle={card.cardTitle}
            cardBgColor={card.cardBgColor}
            cardValue={card.cardValue}
          />
        ))}
      </div>
    </>
  ) : (
    <div className="grid grid-cols-1 gap-4 md:grid-cols-4">
      {cardData.map((card, idx) => (
        <StatCard
          key={idx}
          cardTitle={card.cardTitle}
          cardBgColor={card.cardBgColor}
          cardValue={card.cardValue}
        />
      ))}
    </div>
  );
}

const StatCard = ({ cardTitle, cardBgColor, cardValue }) => (
  <div
    className={`flex items-center justify-between px-6 py-2 ${cardBgColor} font-bold text-md border border-black text-white rounded-lg shadow-sm`}
  >
    <h3>{cardTitle}</h3>
    <p>{cardValue}</p>
  </div>
);
